var map = {
	"./neteller/i18n/n-en-GB.json": [
		2758,
		758
	],
	"./paysafecard/i18n/psc-en-GB.json": [
		5484,
		484
	],
	"./skrill-and-neteller/i18n/sn-en-GB.json": [
		1825,
		825
	],
	"./skrill/i18n/s-en-GB.json": [
		891,
		891
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5984;
module.exports = webpackAsyncContext;